/** apiBaseUrl = mydj-server origin (same as PublicUrl in appsettings.QA). IframeAuth.FrontendBaseUrl on server = SPA origin. */
export const environment = {
  production: true,
  sentryDsn: 'https://30b62fb3975d68bf2394bbbc36629965@sentry.uco.co.il/31',
  sentryEnvironment: 'qa',
  appVersion: '3.11.11',
  buildNumber: 6,
  apiBaseUrl: 'https://wss.win1.tempurl.info',
};





